import { Link } from "react-router-dom";
import { Account } from "../../../../types/account";

export const tableColumns = [
  {
    title: "#",
    dataIndex: "accountID",
    key: "key",
    width: "10%"
  },
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "accountName",
    editable: true
  },
  {
    title: "Account Number",
    dataIndex: "accountNumber",
    key: "accountNumber"
  }
];
